// extracted by mini-css-extract-plugin
module.exports = {"mime-type-indicator":"mime-type-indicator--QfNW1LkuuX","mimeTypeIndicator":"mime-type-indicator--QfNW1LkuuX"};